import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Divider,
  Container,
  Paper,
  Chip,
  CircularProgress,
} from '@mui/material';
import {
  CloudUpload,
  Business,
  Payment,
  People,
  Receipt,
  Construction,
  School,
  Add,
  NetworkPing,
  Router,
  Description,
  Sync,
  Search,
} from '@mui/icons-material';
import {
  ImportClientesModal,
  ImportPlanosModal,
  ImportGatewaysModal,
  ImportMensalidadesModal,
  ImportAdicionalModal,
  ImportSysupoltModal,
  ImportSysupcaixasModal,
  ImportSysupequipamentosModal,
  ImportSysupcircuitosModal,
  ImportSysupcabosModal,
  ImportSysupmarcasModal,
  ImportSysupmodelosModal,
  ImportSysupdespesasModal,
} from '../components/import/mkauth';
import { ImportIxcModal, ImportIxcPlanosModal, ImportIxcContratosModal, ImportIxcDocumentosModal } from '../components/import/ixc';
import GatewaySelect from '../components/selects/GatewaySelect';
import AtualizaFaturasEfiModal from '../components/import/AtualizaFaturasEfiModal';
import gatewayService, { Gateway } from '../services/gatewayService';
import { toast } from 'react-toastify';

export type ImportType = 'planos' | 'gateways' | 'clientes' | 'mensalidades' | 'adicionais' | 'sysupolt' | 'sysupcaixas' | 'sysupequipamentos' | 'sysupcircuitos' | 'sysupcabos' | 'sysupmarcas' | 'sysupmodelos' | 'sysupdespesas';

const ImportDataPage: React.FC = () => {
  const [ixcModalOpen, setIxcModalOpen] = useState(false);
  const [ixcPlanosModalOpen, setIxcPlanosModalOpen] = useState(false);
  const [clientesModalOpen, setClientesModalOpen] = useState(false);
  const [planosModalOpen, setPlanosModalOpen] = useState(false);
  const [gatewaysModalOpen, setGatewaysModalOpen] = useState(false);
  const [mensalidadesModalOpen, setMensalidadesModalOpen] = useState(false);
  const [adicionaisModalOpen, setAdicionaisModalOpen] = useState(false);
  const [sysupoltModalOpen, setSysupoltModalOpen] = useState(false);
  const [sysupcaixasModalOpen, setSysupcaixasModalOpen] = useState(false);
  const [sysupequipamentosModalOpen, setSysupequipamentosModalOpen] = useState(false);
  const [sysupmarcasModalOpen, setSysupmarcasModalOpen] = useState(false);
  const [sysupmodelosModalOpen, setSysupmodelosModalOpen] = useState(false);
  const [sysupcircuitosModalOpen, setSysupcircuitosModalOpen] = useState(false);
  const [sysupcabosModalOpen, setSysupcabosModalOpen] = useState(false);
  const [sysupdespesasModalOpen, setSysupdespesasModalOpen] = useState(false);
  const [ixcContratosModalOpen, setIxcContratosModalOpen] = useState(false);
  const [ixcDocumentosModalOpen, setIxcDocumentosModalOpen] = useState(false);

  // Estado da Seção Atualiza Faturas Efíbank
  const [selectedGatewayId, setSelectedGatewayId] = useState<number | null>(null);
  const [selectedGateway, setSelectedGateway] = useState<Gateway | null>(null);
  const [efiModalOpen, setEfiModalOpen] = useState(false);

  const handleAbrirModalEfi = () => {
    if (!selectedGatewayId) {
      toast.error('Por favor, selecione um gateway de pagamento.');
      return;
    }
    setEfiModalOpen(true);
  };
  const handleOpenModal = (type: ImportType) => {
    switch (type) {
      case 'clientes':
        setClientesModalOpen(true);
        break;
      case 'planos':
        setPlanosModalOpen(true);
        break;
      case 'gateways':
        setGatewaysModalOpen(true);
        break;
      case 'mensalidades':
        setMensalidadesModalOpen(true);
        break;
      case 'adicionais':
        setAdicionaisModalOpen(true);
        break;
      case 'sysupolt':
        setSysupoltModalOpen(true);
        break;
      case 'sysupcaixas':
        setSysupcaixasModalOpen(true);
        break;
      case 'sysupmarcas':
        setSysupmarcasModalOpen(true);
        break;
      case 'sysupmodelos':
        setSysupmodelosModalOpen(true);
        break;
      case 'sysupequipamentos':
        setSysupequipamentosModalOpen(true);
        break;
      case 'sysupcircuitos':
        setSysupcircuitosModalOpen(true);
        break;
      case 'sysupcabos':
        setSysupcabosModalOpen(true);
        break;
      case 'sysupdespesas':
        setSysupdespesasModalOpen(true);
        break;
    }
  };

  const handleCloseModal = () => {
    setIxcModalOpen(false);
    setIxcPlanosModalOpen(false);
    setClientesModalOpen(false);
    setPlanosModalOpen(false);
    setGatewaysModalOpen(false);
    setMensalidadesModalOpen(false);
    setAdicionaisModalOpen(false);
    setSysupoltModalOpen(false);
    setSysupcaixasModalOpen(false);
    setSysupequipamentosModalOpen(false);
    setSysupcircuitosModalOpen(false);
    setSysupcabosModalOpen(false);
    setSysupmarcasModalOpen(false);
    setSysupmodelosModalOpen(false);
    setSysupdespesasModalOpen(false);
    setIxcContratosModalOpen(false);
    setIxcDocumentosModalOpen(false);
  };

  const handleImportSuccess = () => {
    handleCloseModal();
    // Aqui podemos adicionar notificação de sucesso ou refresh de dados
  };

  const mkAuthButtons = [
    {
      type: 'planos' as ImportType,
      title: 'Importar Planos',
      description: 'Importar planos de serviço do MKAuth',
      icon: <Business />,
      color: '#1976d2',
    },
    {
      type: 'gateways' as ImportType,
      title: 'Importar Gateways',
      description: 'Importar gateways de pagamento do MKAuth',
      icon: <Payment />,
      color: '#2e7d32',
    },
    {
      type: 'clientes' as ImportType,
      title: 'Importar Clientes',
      description: 'Importar dados de clientes do MKAuth',
      icon: <People />,
      color: '#ed6c02',
    },
    {
      type: 'adicionais' as ImportType,
      title: 'Importar Adicionais',
      description: 'Importar dados de adicionais do MKAuth',
      icon: <Add />,
      color: '#d32f2f',
    },
    {
      type: 'mensalidades' as ImportType,
      title: 'Importar Mensalidades',
      description: 'Importar dados de mensalidades do MKAuth',
      icon: <Receipt />,
      color: '#9c27b0',
    },
    {
      type: 'sysupolt' as ImportType,
      title: 'Sysup - Importar OLTS',
      description: 'Importar dados de OLTS do Sysup',
      icon: <NetworkPing />,
      color: '#19bacf',
    },
    {
      type: 'sysupcaixas' as ImportType,
      title: 'Sysup - Importar Caixas',
      description: 'Importar dados de Caixas do Sysup',
      icon: <NetworkPing />,
      color: '#cfc319',
    },
    {
      type: 'sysupcabos' as ImportType,
      title: 'Sysup - Importar Cabos',
      description: 'Importar dados de Cabos do Sysup',
      icon: <Router />,
      color: '#424242',
    },
    {
      type: 'sysupcircuitos' as ImportType,
      title: 'Sysup - Importar Circuitos',
      description: 'Importar dados de Circuitos do Sysup',
      icon: <Router />,
      color: '#3dcf19',
    },
    {
      type: 'sysupmarcas' as ImportType,
      title: 'Sysup - Importar Marcas',
      description: 'Importar dados de Marcas do Sysup',
      icon: <Router />,
      color: '#424242',
    },
    {
      type: 'sysupmodelos' as ImportType,
      title: 'Sysup - Importar Modelos',
      description: 'Importar dados de Modelos do Sysup',
      icon: <Router />,
      color: '#424242',
    },
    {
      type: 'sysupequipamentos' as ImportType,
      title: 'Sysup - Importar Equipamentos',
      description: 'Importar dados de Equipamentos do Sysup',
      icon: <Router />,
      color: '#424242',
    },
    {
      type: 'sysupdespesas' as ImportType,
      title: 'Sysup - Importar Despesas',
      description: 'Importar dados de Despesas do Sysup',
      icon: <Router />,
      color: '#424242',
    },
  ];

  return (
    <Box sx={{ p: 1.5 }}>
      {/* Cabeçalho */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom>
            <CloudUpload sx={{ mr: 1, verticalAlign: 'middle' }} />
            Importar Dados
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ fontSize: '0.9rem' }}>
            Importe dados de sistemas externos através de arquivos XML
          </Typography>
        </Box>
      </Box>

      {/* Seção Atualiza Faturas Efíbank */}
      <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
            <Sync color="primary" />
            <Typography variant="h5" component="h2">
              Atualiza Faturas Efíbank
            </Typography>
            <Chip label="Efí API v1" color="primary" size="small" variant="outlined" />
          </Box>
          <Typography variant="body2" color="text.secondary">
            Selecione o gateway para buscar faturas ativas (não canceladas) e atualizar a URL de notificação diretamente no Efíbank.
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={8} md={6}>
            <GatewaySelect
              value={selectedGatewayId ?? ''}
              onChange={(id, gateway) => {
                setSelectedGatewayId(id);
                setSelectedGateway(gateway || null);
              }}
              label="Selecionar Gateway"
              showOnlyActive={false}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<Sync />}
              onClick={handleAbrirModalEfi}
              disabled={!selectedGatewayId}
              sx={{ height: 40 }}
            >
              Executar
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Seção IXC */}
      <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <CloudUpload color="primary" />
            <Typography variant="h5" component="h2">
              IXC
            </Typography>
            <Chip label="API v1" color="primary" size="small" variant="outlined" />
          </Box>
          <Typography variant="body2" color="text.secondary">
            Importe clientes do IXC por etapa: planos, cadastros, contratos, serviços (login), faturas e PIX.
          </Typography>
        </Box>
        <Divider sx={{ my: 3 }} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              sx={{
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 },
              }}
              onClick={() => setIxcPlanosModalOpen(true)}
            >
              <CardContent sx={{ textAlign: 'center', p: 2 }}>
                <Box sx={{ color: '#2e7d32', mb: 1.5, '& svg': { fontSize: '2.5rem' } }}>
                  <Business />
                </Box>
                <Typography variant="h6" component="h3" gutterBottom sx={{ fontSize: '1rem', mb: 1 }}>
                  Importar Planos IXC
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem', mb: 1.5 }}>
                  Listar radgrupos (planos), selecionar e importar (nome = grupo, obs = id IXC)
                </Typography>
                <Button variant="contained" fullWidth size="small" sx={{ mt: 1 }}>
                  Importar
                </Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              sx={{
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 },
              }}
              onClick={() => setIxcModalOpen(true)}
            >
              <CardContent sx={{ textAlign: 'center', p: 2 }}>
                <Box sx={{ color: '#1976d2', mb: 1.5, '& svg': { fontSize: '2.5rem' } }}>
                  <People />
                </Box>
                <Typography variant="h6" component="h3" gutterBottom sx={{ fontSize: '1rem', mb: 1 }}>
                  Importar Clientes IXC
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem', mb: 1.5 }}>
                  Listar clientes na API, selecionar e importar por etapas
                </Typography>
                <Button variant="contained" fullWidth size="small" sx={{ mt: 1 }}>
                  Importar
                </Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              sx={{
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 },
              }}
              onClick={() => setIxcContratosModalOpen(true)}
            >
              <CardContent sx={{ textAlign: 'center', p: 2 }}>
                <Box sx={{ color: '#d32f2f', mb: 1.5, '& svg': { fontSize: '2.5rem' } }}>
                  <Description />
                </Box>
                <Typography variant="h6" component="h3" gutterBottom sx={{ fontSize: '1rem', mb: 1 }}>
                  Importar Contratos (PDF) IXC
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem', mb: 1.5 }}>
                  Busca todos os contratos com ID de Importação e baixa o PDF da API
                </Typography>
                <Button variant="contained" fullWidth size="small" sx={{ mt: 1 }}>
                  Importar
                </Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              sx={{
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 },
              }}
              onClick={() => setIxcDocumentosModalOpen(true)}
            >
              <CardContent sx={{ textAlign: 'center', p: 2 }}>
                <Box sx={{ color: '#ff9800', mb: 1.5, '& svg': { fontSize: '2.5rem' } }}>
                  <CloudUpload />
                </Box>
                <Typography variant="h6" component="h3" gutterBottom sx={{ fontSize: '1rem', mb: 1 }}>
                  Importar Documentos IXC
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem', mb: 1.5 }}>
                  Busca todos os arquivos anexados aos clientes no IXC (RG, CPF, Comprovantes, etc)
                </Typography>
                <Button variant="contained" color="warning" fullWidth size="small" sx={{ mt: 1 }}>
                  Importar
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Paper>

      {/* Seção MKAuth */}
      <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <CloudUpload color="primary" />
            <Typography variant="h5" component="h2">
              MKAuth
            </Typography>
            <Chip
              label="Ativo"
              color="success"
              size="small"
              variant="outlined"
            />
          </Box>
          <Typography variant="body2" color="text.secondary">
            Importe dados do sistema MKAuth através de arquivos XML
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Grid container spacing={2}>
          {mkAuthButtons.map((button) => (
            <Grid item xs={12} sm={6} md={2.4} key={button.type}>
              <Card
                sx={{
                  height: '100%',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: 3,
                  }
                }}
                onClick={() => handleOpenModal(button.type)}
              >
                <CardContent sx={{ textAlign: 'center', p: 2 }}>
                  <Box
                    sx={{
                      color: button.color,
                      mb: 1.5,
                      '& svg': { fontSize: '2.5rem' }
                    }}
                  >
                    {button.icon}
                  </Box>
                  <Typography variant="h6" component="h3" gutterBottom sx={{ fontSize: '1rem', mb: 1 }}>
                    {button.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem', mb: 1.5 }}>
                    {button.description}
                  </Typography>
                  <Button
                    variant="contained"
                    fullWidth
                    size="small"
                    sx={{
                      mt: 1,
                      backgroundColor: button.color,
                      '&:hover': {
                        backgroundColor: button.color,
                        filter: 'brightness(0.9)',
                      }
                    }}
                  >
                    Importar
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>

      {/* Seção SGP */}
      <Paper elevation={2} sx={{ p: 3 }}>
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <School color="disabled" />
            <Typography variant="h5" component="h2" color="text.disabled">
              SGP
            </Typography>
            <Chip
              label="Em breve"
              color="default"
              size="small"
              variant="outlined"
            />
          </Box>
          <Typography variant="body2" color="text.secondary">
            Funcionalidade de importação do SGP será implementada no futuro
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Construction sx={{ fontSize: '4rem', color: 'text.disabled', mb: 2 }} />
          <Typography variant="h6" color="text.disabled" gutterBottom>
            Em Desenvolvimento
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Esta funcionalidade estará disponível em breve
          </Typography>
        </Box>
      </Paper>

      {/* Modais de Importação */}
      <ImportIxcModal
        open={ixcModalOpen}
        onClose={() => setIxcModalOpen(false)}
        onSuccess={handleImportSuccess}
      />
      <ImportIxcPlanosModal
        open={ixcPlanosModalOpen}
        onClose={() => setIxcPlanosModalOpen(false)}
        onSuccess={handleImportSuccess}
      />
      <ImportIxcContratosModal
        open={ixcContratosModalOpen}
        onClose={() => setIxcContratosModalOpen(false)}
        onSuccess={handleImportSuccess}
      />
      <ImportIxcDocumentosModal
        open={ixcDocumentosModalOpen}
        onClose={() => setIxcDocumentosModalOpen(false)}
        onSuccess={handleImportSuccess}
      />
      <ImportClientesModal
        open={clientesModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportPlanosModal
        open={planosModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportGatewaysModal
        open={gatewaysModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportMensalidadesModal
        open={mensalidadesModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportAdicionalModal
        open={adicionaisModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportSysupoltModal
        open={sysupoltModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportSysupcaixasModal
        open={sysupcaixasModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportSysupequipamentosModal
        open={sysupequipamentosModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportSysupcircuitosModal
        open={sysupcircuitosModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportSysupcabosModal
        open={sysupcabosModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportSysupmarcasModal
        open={sysupmarcasModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportSysupmodelosModal
        open={sysupmodelosModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <ImportSysupdespesasModal
        open={sysupdespesasModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleImportSuccess}
      />

      <AtualizaFaturasEfiModal
        open={efiModalOpen}
        onClose={() => setEfiModalOpen(false)}
        selectedGateway={selectedGateway}
        onSuccess={handleImportSuccess}
      />
    </Box>
  );
};

export default ImportDataPage;